module.exports = __webpack_public_path__ + "e1c473997e356d1b88207beaa0678836.svg";